import { useMemo } from "react";

import { ExperienceListDto } from "@intelligems/ig-types/dtos/experiences-list";

import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";

const isCartTransformTestConflictActive = (
  experiences: Pick<ExperienceListDto, "id" | "status" | "testTypes">[],
  cartTransformMode: string | undefined,
  currentExperienceId: string | undefined,
  testType: "hasTestPricing" | "hasTestShipping"
): boolean => {
  if (cartTransformMode !== "expand") {
    return false;
  }
  const conflictingTestType =
    testType === "hasTestPricing" ? "hasTestShipping" : "hasTestPricing";
  return experiences.some(
    (experience) =>
      experience.id !== currentExperienceId &&
      experience.status === "started" &&
      experience.testTypes[conflictingTestType]
  );
};

export const useIsCartTransformTestConflictActive = (
  experienceId: string | undefined,
  testType: "hasTestPricing" | "hasTestShipping",
  enabled = true
) => {
  const conflictingModule =
    testType === "hasTestPricing" ? "shipping" : "pricing";
  const experiencesList = useGetExperiencesList({
    module: conflictingModule,
    enabled,
  });
  const cartTransformMode = useConfiguration<string>(
    "cart_transform_mode"
  )?.value;

  return useMemo(
    () =>
      isCartTransformTestConflictActive(
        experiencesList.data?.experiencesList ?? [],
        cartTransformMode,
        experienceId,
        testType
      ),
    [experiencesList, cartTransformMode, experienceId, testType]
  );
};
